// material
import { Box, Grid, Container, Typography } from "@mui/material";
import { useState, useEffect } from "react";
// components
import Page from "../components/Page";
import {
  AppTasks,
  InfoCard,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  PieChart,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  HorizontalBarChart,
} from "../components/_dashboard/app";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import { useTheme, styled } from "@mui/material/styles";
import personAddFill from "@iconify/icons-eva/person-add-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import videoSecurity20Filled from "@iconify/icons-fluent/video-security-20-filled";
import petsIcon from "@iconify/icons-dashicons/pets";
import LinearProgress from "@mui/material/LinearProgress";
import warning24Filled from "@iconify/icons-fluent/warning-24-filled";
import cloudUpload from "@iconify/icons-mdi/cloud-upload";
import plantFill from "@iconify/icons-ri/plant-fill";
import restartIcon from "@iconify/icons-mdi/restart";
import faceMask from "@iconify/icons-mdi/face-mask";
import baselineGrain from "@iconify/icons-ic/baseline-grain";
import { fNumber } from "../utils/formatNumber";
import ReactApexChart from "react-apexcharts";
import { BaseOptionChart } from "../components/charts";
import { merge } from "lodash";
// ----------------------------------------------------------------------

const CHART_DATA = [
  {
    name: "Team A",
    type: "column",
    data: [23, 27],
  },
  {
    name: "Team B",
    type: "column",
    data: [44],
  },
  {
    name: "Team C",
    type: "column",
    data: [30, 25, 36],
  },
];

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible",
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

export default function DashboardApp() {
  const theme = useTheme();
  const [dataLoading, setDataLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalLocations, setTotalLocations] = useState(0);
  const [totalProblemDetected, setTotalProblemDetected] = useState(0);
  const [totalImageUploaded, setTotalImageUploaded] = useState(0);
  const [totalProductDefined, setTotalProductDefined] = useState(0);
  const [durationOfCultivation, setDurationOfCultivation] = useState(0);
  const [numOfPoisoning, setNumOfPoisoning] = useState(0);
  const [numOffertilization, setNumOffertilization] = useState(0);
  const [chartOptions1, setChartOptions1] = useState(
    merge(BaseOptionChart(), {
      tooltip: {
        shared: false,
        intersect: false,
        y: {
          formatter: (y) => {
            if (typeof y !== "undefined") {
              return `${y.toFixed(0)}`;
            }
            return y;
          },
        },
      },
    })
  );
  const [chartOptions2, setChartOptions2] = useState(
    merge(BaseOptionChart(), {
      tooltip: {
        shared: false,
        intersect: false,
        y: {
          formatter: (y) => {
            if (typeof y !== "undefined") {
              return `${y.toFixed(0)} problem deteced`;
            }
            return y;
          },
        },
      },
    })
  );
  const [chartOptions3, setChartOptions3] = useState(
    merge(BaseOptionChart(), {
      tooltip: {
        shared: false,
        intersect: false,
        y: {
          formatter: (y) => {
            if (typeof y !== "undefined") {
              return `${y.toFixed(0)}`;
            }
            return y;
          },
        },
      },
    })
  );

  const [pieChartOptions, setPieChartOptions] = useState(
    merge(BaseOptionChart(), {
      colors: [
        theme.palette.error.main,
        theme.palette.primary.main,
        theme.palette.info.main,
        theme.palette.warning.main,
      ],
      labels: ["Problem Detected", "Not Detected"],
      stroke: { colors: [theme.palette.background.paper] },
      legend: { floating: true, horizontalAlign: "center" },
      dataLabels: { enabled: true, dropShadow: { enabled: false } },
      tooltip: {
        fillSeriesColor: false,
        y: {
          formatter: (seriesName) => fNumber(seriesName),
          title: {
            formatter: (seriesName) => `${seriesName}: `,
          },
        },
      },
      plotOptions: {
        pie: { donut: { labels: { show: false } } },
      },
    })
  );
  const [numOfLocationpMonth, setNumOfLocationpMonth] = useState([]);
  const [numOfPicbProductpMonth, setNumOfPicbProductpMonth] = useState([]);
  const [numOfUserpMonth, setNumOfUserpMonth] = useState([]);
  const [problemPercentpProduct, setProblemPercentpProduct] = useState([]);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
    };

    setDataLoading(true);
    fetch("/cpapi/getDashboradReports", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        try {
          console.log("getDashboradReports", result);

          setTotalUsers(result.reports.totalUsers);
          setTotalLocations(result.reports.totallocations);
          setTotalProblemDetected(result.reports.totalProblemDetected);
          setTotalProductDefined(result.reports.totalProductDefined);
          setTotalImageUploaded(result.reports.totalImageUploaded);
          setDurationOfCultivation(result.reports.durationOfCultivation);
          setNumOfPoisoning(result.reports.numOfPoisoning);
          setNumOffertilization(result.reports.numOffertilization);
          setProblemPercentpProduct(result.reports.problemPercentpProduct);

          let temp = result.reports.numOfLocationpMonth;
          let cats = [];
          let cats1 = [];
          let cats2 = [];
          let report1Data = [];
          let report2Data = [];
          let report3Data = [];
          temp.forEach((element) => {
            cats.push(element.month);
            report1Data.push(element.countOfLocation);
          });

          temp = result.reports.numOfUserpMonth;
          temp.forEach((element) => {
            cats2.push(element.month);
            report3Data.push(element.countOfUser);
          });

          temp = result.reports.numOfPicbProductpMonth;
          temp.forEach((element) => {
            let found = false;
            cats1.forEach((element1) => {
              if (element1 === element.month) {
                found = true;
              }
            });
            if (!found) cats1.push(element.month);

            found = false;
            report2Data.forEach((element1) => {
              if (element1.name === element.productTypeTitle) {
                found = true;
              }
            });
            if (!found)
              report2Data.push({
                name: element.productTypeTitle,
                data: [],
                type: "column",
              });
          });

          cats1.forEach((element) => {
            report2Data.forEach((element1) => {
              let found = false;
              temp.forEach((element2) => {
                if (
                  element === element2.month &&
                  element1.name === element2.productTypeTitle
                ) {
                  found = true;
                  element1.data.push(element2.numOfPicpProductpMonth);
                }
              });
              if (!found) {
                element1.data.push(0);
              }
            });
          });

          console.log(cats1);
          console.log(report2Data);

          // report2Data.forEach((element1) => {
          //   if (element1.name === element.productTypeTitle) {
          //     found = true;
          //     element1.data.push(element.numOfPicpProductpMonth);
          //   }
          // });
          // if (!found) {
          //   report2Data.push({
          //     name: element.productTypeTitle,
          //     data: [element.numOfPicpProductpMonth],
          //     type: "column",
          //   });
          // }

          let options1 = chartOptions1;
          let options2 = chartOptions2;
          let options3 = chartOptions1;
          options1.xaxis = { categories: cats };
          options2.xaxis = { categories: cats1 };
          options3.xaxis = { categories: cats2 };
          setChartOptions1(options1);
          setChartOptions2(options2);
          setChartOptions3(options3);
          setNumOfLocationpMonth([
            {
              name: "Locations",
              type: "column",
              data: report1Data,
            },
          ]);
          setNumOfUserpMonth([
            {
              name: "Users",
              type: "column",
              data: report3Data,
            },
          ]);

          // console.log(report2Data);
          setNumOfPicbProductpMonth(report2Data);

          setDataLoading(false);
        } catch (error) {
          console.log("error: ", error);
        }
      });
  }, []);

  const getSeries = (item) => {
    return [
      item.numOfProblemDetectedpProduct,
      item.numOfPicpProduct - item.numOfProblemDetectedpProduct,
    ];
  };

  return (
    <Page title="Dashboard | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container maxWidth="xl">
          <Box sx={{ pb: 5 }}>
            <Typography variant="h4">Hi, Welcome back</Typography>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Users"
                color1={theme.palette.info.lighter}
                color2={theme.palette.info.darker}
                icon={personAddFill}
                value={totalUsers}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Locations"
                color1={theme.palette.success.lighter}
                color2={theme.palette.success.darker}
                icon={pinFill}
                value={totalLocations}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Problem Detected"
                color1={theme.palette.warning.lighter}
                color2={theme.palette.warning.darker}
                icon={warning24Filled}
                value={totalProblemDetected}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Product Defined"
                color1={theme.palette.error.lighter}
                color2={theme.palette.error.darker}
                icon={plantFill}
                value={totalProductDefined}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Image Uploaded"
                color1={theme.palette.secondary.lighter}
                color2={theme.palette.secondary.darker}
                icon={cloudUpload}
                value={totalImageUploaded}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Duration Of Cultivation"
                color1={theme.palette.info.lighter}
                color2={theme.palette.info.darker}
                icon={restartIcon}
                value={durationOfCultivation}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Sparying"
                color1={theme.palette.error.lighter}
                color2={theme.palette.error.darker}
                icon={faceMask}
                value={numOfPoisoning}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InfoCard
                text="Total Fertilization"
                color1={theme.palette.success.lighter}
                color2={theme.palette.success.darker}
                icon={baselineGrain}
                value={numOffertilization}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardHeader title="Location Per Month" />
                <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                  <ReactApexChart
                    type="bar"
                    series={numOfLocationpMonth}
                    options={chartOptions1}
                    height={364}
                  />
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardHeader title="Picture of Products Per Month" />
                <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                  <ReactApexChart
                    type="bar"
                    // series={CHART_DATA}
                    series={numOfPicbProductpMonth}
                    options={chartOptions2}
                    height={364}
                  />
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardHeader title="Total Users Per Month" />
                <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                  <ReactApexChart
                    type="bar"
                    series={numOfUserpMonth}
                    options={chartOptions3}
                    height={364}
                  />
                </Box>
              </Card>
            </Grid>

            {problemPercentpProduct.map((item, i) => {
              return (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Card>
                    <CardHeader title={item.productTypeTitle} />
                    <ChartWrapperStyle dir="ltr">
                      <ReactApexChart
                        type="pie"
                        series={getSeries(item)}
                        options={pieChartOptions}
                        height={280}
                      />
                    </ChartWrapperStyle>
                  </Card>
                </Grid>
              );
            })}

            {/* <Grid item xs={12} md={12} lg={12}>
              <HorizontalBarChart
                cats={animalCats}
                data={animalData}
                title="Animals"
                subtitle=""
              />
            </Grid> */}

            {/* <Grid item xs={12} md={6} lg={4}>
              <PieChart
                cats={["Active", "Disable"]}
                data={[2408, 482]}
                title="Cameras"
              />
            </Grid> */}

            {/* <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks />
          </Grid> */}
          </Grid>
        </Container>
      )}
    </Page>
  );
}
